import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  videoBox: () => [
    import(
      './viewer/skinComps/VideoBox/videoBox.skin' /* webpackChunkName: "VideoBox" */
    ),
  ],
  videoBoxResponsive: () => [
    import(
      './viewer/skinComps/VideoBoxResponsive/videoBoxResponsive.skin' /* webpackChunkName: "VideoBoxResponsive" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('MediaPlayer', UiTypes),
};

export default entry;
